/* ValueScope.type.js */

/**
 * @typedef ValueScopeType
 * @enum {string}
 */
module.exports = {
    PARENT: "Parent",
    ISOLATED: "Isolated",
    REPLACE: "Replaced",
    OBJECT: "ObjectLevel",
};
Object.freeze(module.exports);
